import cn from 'classnames';
import { CheckIcon } from '#assets/ReactSvg.ts';
import { DetailCard } from '#components/atoms/cards/detail-card/DetailCard.tsx';
import { Link } from '#components/atoms/link/Link.tsx';
import { Pill } from '#components/atoms/pill/Pill.tsx';
import { MeatballMenu, MenuItem } from '#components/patterns/menus/meatball-menu/index.ts';
import type { IdentityProvider } from '#screens/settings/sso/types.ts';
import styles from './IdentityProviderDetails.module.css';

type Props = {
  idp: IdentityProvider;
  menuProps?: {
    onToggleEnabled: (() => void) | (() => Promise<void>);
    onRemove: () => void;
  };
};

export function IdentityProviderDetails({ idp, menuProps }: Props) {
  const { enabled, clientID, issuerURL } = idp;

  return (
    <DetailCard>
      <div
        className={cn(styles.IdentityProviderDetails, {
          [styles.IdentityProviderDetails___showMenu]: Boolean(menuProps),
        })}
      >
        <p className={cn('p-md', styles.IdentityProviderDetails_key)}>Status</p>
        <div className={cn('p-bold', styles.IdentityProviderDetails_value)}>
          {enabled ?
            <Pill variant="success" Icon={CheckIcon}>
              Enabled
            </Pill>
          : <Pill variant="default">Disabled</Pill>}
        </div>
        <p className={cn('p-md', styles.IdentityProviderDetails_key)}>Client ID</p>
        <p className={cn('p-bold', styles.IdentityProviderDetails_value, styles.IdentityProviderDetails___breakAll)}>
          {clientID}
        </p>
        <p className={cn('p-md', styles.IdentityProviderDetails_key)}>Issuer URL</p>
        <p className={cn('p-bold', styles.IdentityProviderDetails_value, styles.IdentityProviderDetails___truncate)}>
          {issuerURL}
        </p>
        {menuProps ?
          <div className={styles.IdentityProviderDetails_menu}>
            <MeatballMenu aria-label="Modify provider">
              <MenuItem render={<Link to="edit" />}>Edit</MenuItem>
              <MenuItem onClick={() => menuProps.onToggleEnabled()}>{enabled ? 'Disable' : 'Enable'}</MenuItem>
              <MenuItem onClick={() => menuProps.onRemove()}>Delete</MenuItem>
            </MeatballMenu>
          </div>
        : null}
      </div>
    </DetailCard>
  );
}
